// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.processingSourcesCard_wrapper__7-OSu {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 13px;
  padding-bottom: 13px; }

.processingSourcesCard_fileImage__TIBms {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: flex-start;
  width: 20%; }

.processingSourcesCard_dataContainer__UOa4t {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; }

.processingSourcesCard_plainText__tBSad {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #666666; }

.processingSourcesCard_actionsBlock__xrl5v {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px; }
  .processingSourcesCard_actionsBlock__xrl5v svg {
    color: #666666;
    cursor: pointer; }

.processingSourcesCard_modal__UCl9W {
  max-width: 560px;
  max-height: 850px;
  height: max-content;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  z-index: 2; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/processingFileCard/processingSourcesCard.module.scss","webpack://./src/styles/common.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB,EAAA;;AAGtB;ECTE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EDSvB,2BAA2B;EAC3B,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EEmBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EFnBjB,cAA6B,EAAA;;AAG/B;EC3BE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;ED2BvB,eAAe,EAAA;EAFjB;IAII,cAA6B;IAC7B,eAAe,EAAA;;AAInB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 13px;\n  padding-bottom: 13px;\n}\n\n.fileImage {\n  @include flexCenter;\n  justify-content: flex-start;\n  width: 20%;\n}\n\n.dataContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.plainText {\n  @include body2;\n  color: rgba(102, 102, 102, 1);\n}\n\n.actionsBlock {\n  @include flexCenter;\n  column-gap: 8px;\n  svg {\n    color: rgba(102, 102, 102, 1);\n    cursor: pointer;\n  }\n}\n\n.modal {\n  max-width: 560px;\n  max-height: 850px;\n  height: max-content;\n  overflow: hidden;\n  position: relative;\n  background-color: #ffffff;\n  z-index: 2;\n}","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `processingSourcesCard_wrapper__7-OSu`,
	"fileImage": `processingSourcesCard_fileImage__TIBms`,
	"dataContainer": `processingSourcesCard_dataContainer__UOa4t`,
	"plainText": `processingSourcesCard_plainText__tBSad`,
	"actionsBlock": `processingSourcesCard_actionsBlock__xrl5v`,
	"modal": `processingSourcesCard_modal__UCl9W`
};
export default ___CSS_LOADER_EXPORT___;
